// extracted by mini-css-extract-plugin
module.exports = {"navbar":"CompanyIntegrations_navbar__mTfXG","active":"CompanyIntegrations_active__29zva"};